import DashboardShell, { StatCard } from "@/components/DashboardShell";
import QueueTable, { useQueue } from "@/components/QueueTable";

export default function ReviewerQueue() {
  const [rows] = useQueue({});
  const n = (s) => (rows || []).filter((r) => r.review_status === s).length;
  return (
    <DashboardShell title="My review queue" subtitle="School Fees Loans and Academic Liquidity Advances assigned to you. Action each within 48 hours.">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Pending Review" value={rows ? n("pending_review") : "…"} accent="warning" />
        <StatCard label="In Review" value={rows ? n("in_review") : "…"} />
        <StatCard label="Approved" value={rows ? n("approved") : "…"} accent="success" />
        <StatCard label="Declined" value={rows ? n("declined") : "…"} accent="warning" />
      </div>
      <QueueTable rows={rows} base="/approver/review" />
    </DashboardShell>
  );
}
